import AddToCartOrderButton from "./components/AddToCartOrderButton";

require("./storefront");
require('spectrum-colorpicker');
const _ = require('lodash');

import Vue from "vue";
import store from "./store";
import {notify, trans, chunk, getImg, getImg2, scrollToElement, Toast} from "./functions";
import VueToast from "vue-toast-notification";
import vClickOutside from "v-click-outside";
import VueSweetalert2 from 'vue-sweetalert2';
import PortalVue from 'portal-vue';

import VPagination from "./components/VPagination.vue";
import HeaderSearch from "./components/layout/HeaderSearch.vue";
import SidebarCart from "./components/layout/SidebarCart";
import NewsletterPopup from "./components/layout/NewsletterPopup";
import NewsletterSubscription from "./components/layout/NewsletterSubscription";
import CookieBar from "./components/layout/CookieBar";
import LandscapeProducts from "./components/LandscapeProducts.vue";
import DynamicTab from "./components/home/DynamicTab";
import HomeFeatures from "./components/home/HomeFeatures.vue";
import FeaturedCategories from "./components/home/FeaturedCategories.vue";
import BannerThreeColumnFullWidth from "./components/home/BannerThreeColumnFullWidth.vue";
import ProductTabsOne from "./components/home/ProductTabsOne.vue";
import TopBrands from "./components/home/TopBrands.vue";
import FlashSaleAndVerticalProducts from "./components/home/FlashSaleAndVerticalProducts.vue";
import FlashSale from "./components/home/FlashSale.vue";
import BannerTwoColumn from "./components/home/BannerTwoColumn.vue";
import VerticalProducts from "./components/home/VerticalProducts.vue";
import ProductGrid from "./components/home/ProductGrid.vue";
import BannerThreeColumn from "./components/home/BannerThreeColumn.vue";
import ProductTabsTwo from "./components/home/ProductTabsTwo.vue";
import BannerOneColumn from "./components/home/BannerOneColumn.vue";
import ProductIndex from "./components/products/Index";
import ProductCardGridView from "./components/products/index/ProductCardGridView.vue";
import ProductCardListView from "./components/products/index/ProductCardListView.vue";
import ProductCardVertical from "./components/ProductCardVertical.vue";
import ProductShow from "./components/products/Show";
import CartIndex from "./components/cart/Index";
import CheckoutCreate from "./components/checkout/Create";
import CompareIndex from "./components/compare/Index";
import MyWishlist from "./components/account/wishlist/Index";
import MyAddresses from "./components/account/addresses/Index";
import ImageEditor from "./components/ImageEditor";
import ColorPicker from "./components/forms/ColorPicker";
import Modal from "./components/Modal";
import FileUpload from "./components/forms/FileUpload";
import ScrollBox from "./components/ScrollBox";
import Select from "./components/forms/Select";
import RangeSlider from "./components/forms/RangeSlider";
import LabelForm from "./components/labelForm/LabelForm";
import FlexiblePackagingForm from "./components/flexible-packaging/FlexiblePackagingForm";
import OrderDetails from "./components/account/OrderDetails";
import Swal from 'sweetalert2';
import Alpine from 'alpinejs';

window.$swal = Toast;
Vue.prototype.route = route;
Vue.prototype.$notify = notify;
Vue.prototype.$trans = trans;
window.$trans = trans;
Vue.prototype.$chunk = chunk;
Vue.prototype.$getImg = getImg;
Vue.prototype.$getImg2 = getImg2;
window.$scrollToElement = scrollToElement;

Vue.use(VueToast);
Vue.use(vClickOutside);
Vue.use(VueSweetalert2);
Vue.use(PortalVue)

Vue.component("v-pagination", VPagination);
Vue.component("header-search", HeaderSearch);
Vue.component("sidebar-cart", SidebarCart);
Vue.component("newsletter-popup", NewsletterPopup);
Vue.component("newsletter-subscription", NewsletterSubscription);
Vue.component("cookie-bar", CookieBar);
Vue.component("landscape-products", LandscapeProducts);
Vue.component("dynamic-tab", DynamicTab);
Vue.component("home-features", HomeFeatures);
Vue.component("featured-categories", FeaturedCategories);
Vue.component("banner-three-column-full-width", BannerThreeColumnFullWidth);
Vue.component("product-tabs-one", ProductTabsOne);
Vue.component("top-brands", TopBrands);
Vue.component("flash-sale-and-vertical-products", FlashSaleAndVerticalProducts);
Vue.component("flash-sale", FlashSale);
Vue.component("banner-two-column", BannerTwoColumn);
Vue.component("vertical-products", VerticalProducts);
Vue.component("product-grid", ProductGrid);
Vue.component("banner-three-column", BannerThreeColumn);
Vue.component("product-tabs-two", ProductTabsTwo);
Vue.component("banner-one-column", BannerOneColumn);
Vue.component("product-index", ProductIndex);
Vue.component("product-card-grid-view", ProductCardGridView);
Vue.component("product-card-list-view", ProductCardListView);
Vue.component("product-card-vertical", ProductCardVertical);
Vue.component("product-show", ProductShow);
Vue.component("cart-index", CartIndex);
Vue.component("checkout-create", CheckoutCreate);
Vue.component("compare-index", CompareIndex);
Vue.component("my-wishlist", MyWishlist);
Vue.component("my-addresses", MyAddresses);
Vue.component("label-form", LabelForm);
Vue.component("full-label-form", FullLabelForm);
Vue.component("image-editor", ImageEditor);
Vue.component("color-picker", ColorPicker);
Vue.component("modal", Modal);
Vue.component("file-upload", FileUpload);
Vue.component("scroll-box", ScrollBox);
Vue.component("c-select", Select);
Vue.component("range-slider", RangeSlider);
Vue.component("add-to-cart-existing", AddToCartOrderButton);
Vue.component("order-sample", OrderSampleButton);
Vue.component("flexible-packaging-form", FlexiblePackagingForm);
Vue.component("option-trigger", OptionTrigger);
Vue.component("order-details", OrderDetails);

import { createPinia, PiniaVuePlugin } from 'pinia'

Vue.use(PiniaVuePlugin);
const pinia = createPinia()

new Vue({
    el: "#app",
    pinia,

    computed: {
        cart() {
            return store.state.cart;
        },

        wishlistCount() {
            return store.wishlistCount();
        },
    },
});

$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": FleetCart.csrfToken,
    },
});

// 🤮
(function(v,q){"function"===typeof define&&define.amd?define(q):"object"===typeof exports?module.exports=q():v.ResizeSensor=q()})("undefined"!==typeof window?window:this,function(){function v(b,e){var c=Object.prototype.toString.call(b),k=0,h=b.length;if("[object Array]"===c||"[object NodeList]"===c||"[object HTMLCollection]"===c||"[object Object]"===c||"undefined"!==typeof jQuery&&b instanceof jQuery||"undefined"!==typeof Elements&&b instanceof Elements)for(;k<h;k++)e(b[k]);else e(b)}function q(b){if(!b.getBoundingClientRect)return{width:b.offsetWidth,
    height:b.offsetHeight};b=b.getBoundingClientRect();return{width:Math.round(b.width),height:Math.round(b.height)}}function r(b,e){Object.keys(e).forEach(function(c){b.style[c]=e[c]})}if("undefined"===typeof window)return null;var m="undefined"!=typeof window&&Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")(),z=m.requestAnimationFrame||m.mozRequestAnimationFrame||m.webkitRequestAnimationFrame||function(b){return m.setTimeout(b,20)},G=m.cancelAnimationFrame||
    m.mozCancelAnimationFrame||m.webkitCancelAnimationFrame||function(b){m.clearTimeout(b)},w=function(b,e){function c(){var a=[];this.add=function(d){a.push(d)};var g,f;this.call=function(d){g=0;for(f=a.length;g<f;g++)a[g].call(this,d)};this.remove=function(d){var l=[];g=0;for(f=a.length;g<f;g++)a[g]!==d&&l.push(a[g]);a=l};this.length=function(){return a.length}}function k(a,g){if(a)if(a.resizedAttached)a.resizedAttached.add(g);else{a.resizedAttached=new c;a.resizedAttached.add(g);a.resizeSensor=document.createElement("div");
    a.resizeSensor.dir="ltr";a.resizeSensor.className="resize-sensor";var f={pointerEvents:"none",position:"absolute",left:"0px",top:"0px",right:"0px",bottom:"0px",overflow:"hidden",zIndex:"-1",visibility:"hidden",maxWidth:"100%"},d={position:"absolute",left:"0px",top:"0px",transition:"0s"};r(a.resizeSensor,f);var l=document.createElement("div");l.className="resize-sensor-expand";r(l,f);var x=document.createElement("div");r(x,d);l.appendChild(x);var n=document.createElement("div");n.className="resize-sensor-shrink";
    r(n,f);f=document.createElement("div");r(f,d);r(f,{width:"200%",height:"200%"});n.appendChild(f);a.resizeSensor.appendChild(l);a.resizeSensor.appendChild(n);a.appendChild(a.resizeSensor);d=(d=window.getComputedStyle(a))?d.getPropertyValue("position"):null;"absolute"!==d&&"relative"!==d&&"fixed"!==d&&"sticky"!==d&&(a.style.position="relative");var B=!1,A=0,t=q(a),C=0,D=0,E=!0;h=0;var H=function(){var p=a.offsetWidth,u=a.offsetHeight;x.style.width=p+10+"px";x.style.height=u+10+"px";l.scrollLeft=p+10;
        l.scrollTop=u+10;n.scrollLeft=p+10;n.scrollTop=u+10},y=function(){if(E){if(0===a.offsetWidth&&0===a.offsetHeight){h||(h=z(function(){h=0;y()}));return}E=!1}H()};a.resizeSensor.resetSensor=y;var I=function(){A=0;B&&(C=t.width,D=t.height,a.resizedAttached&&a.resizedAttached.call(t))};d=function(){t=q(a);(B=t.width!==C||t.height!==D)&&!A&&(A=z(I));y()};f=function(p,u,F){p.attachEvent?p.attachEvent("on"+u,F):p.addEventListener(u,F)};f(l,"scroll",d);f(n,"scroll",d);h=z(function(){h=0;y()})}}var h=0;v(b,
    function(a){k(a,e)});this.detach=function(a){h&&(G(h),h=0);w.detach(b,a)};this.reset=function(){b.resizeSensor.resetSensor&&b.resizeSensor.resetSensor()}};w.reset=function(b){v(b,function(e){b.resizeSensor.resetSensor&&e.resizeSensor.resetSensor()})};w.detach=function(b,e){v(b,function(c){if(c){if(c.resizedAttached&&"function"===typeof e&&(c.resizedAttached.remove(e),c.resizedAttached.length()))return;c.resizeSensor&&(c.contains(c.resizeSensor)&&c.removeChild(c.resizeSensor),delete c.resizeSensor,
    delete c.resizedAttached)}})};if("undefined"!==typeof MutationObserver){var J=new MutationObserver(function(b){for(var e in b)if(b.hasOwnProperty(e))for(var c=b[e].addedNodes,k=0;k<c.length;k++)c[k].resizeSensor&&w.reset(c[k])});document.addEventListener("DOMContentLoaded",function(b){J.observe(document.body,{childList:!0,subtree:!0})})}return w});

import StickySidebar from 'sticky-sidebar';
import FullLabelForm from "./components/labelForm/FullLabelForm";
import OptionTrigger from "./components/products/OptionTrigger";
import OrderSampleButton from "./components/OrderSampleButton";

const sidebarDiv = document.querySelector('.sidebar-materials');
if(sidebarDiv !== null) {
    var sidebar = new StickySidebar('.sidebar-materials', {
        containerSelector: '.main-content-materials',
        innerWrapperSelector: '.sidebar-inner-materials',
        topSpacing: 112,
        bottomSpacing: 70,
    });
}

// do not delete this script below

// var accordionLinks = document.querySelectorAll('.faq-link');
//
// if(accordionLinks !== null) {
//
//     for (var i = 0; i < accordionLinks.length; i++) {
//         accordionLinks[i].addEventListener("click", function(event) {
//             event.preventDefault();
//             var card = this.closest('.card');
//             var isActive = card.classList.contains('active-faq');
//
//             for (var j = 0; j < accordionLinks.length; j++) {
//                 accordionLinks[j].closest('.card').classList.remove("active-faq");
//             }
//
//             if (!isActive) {
//                 card.classList.add("active-faq");
//             }
//         });
//     }
//
// }

$(document).ready(function() {
    var isProcessing = false;

    $('.faq-link').click(function(event) {
        event.preventDefault();

        if (isProcessing) {
            return; // Exit if a click event is already being processed
        }

        isProcessing = true;
        var link = $(this);

        var card = link.closest('.card');
        var isActive = card.hasClass('active-faq');

        $('.card').removeClass('active-faq');

        if (!isActive) {
            card.addClass('active-faq');
        }

        setTimeout(function() {
            isProcessing = false;
        }, 300); // Allow clicking after 3 seconds
    });
});

window.Alpine = Alpine
Alpine.start()
